const modules = require.context('./modules', true, /\.vue/)

export default Vue => {
    modules.keys().forEach(item => {
        const component = modules(item).default || modules(item)
        Vue.component(component.name, component)
    })
}



// WEBPACK FOOTER //
// ./src/components/index.js